import { render, staticRenderFns } from "./pep.vue?vue&type=template&id=4486e3c1"
import script from "./pep.vue?vue&type=script&lang=js"
export * from "./pep.vue?vue&type=script&lang=js"
import style0 from "./pep.vue?vue&type=style&index=0&id=4486e3c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports